export default __webpack_public_path__ + "static/media/kheng-letters1.cae43c84.jpg";